export function buildPdfLink(id: string): string {
  return `https://${process.env.REACT_APP_API_BASE_URL}/pdf/Prod/download/${id}`;
}
